module.exports = __webpack_public_path__ + "static/media/dd64bd59-c583-49e8-9ae1-79203ae83471.6c870dbd.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/dd64bd59-c583-49e8-9ae1-79203ae83471.jpg
// module id = 857
// module chunks = 0